import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import CryptoJS from 'crypto-js';
import { getReasonSubReason, getShipmentTypeList, updateProofs, getaudittrails, clientlevelconfigs } from '../../../services/externalDispute';

export default {
  name: 'DisputeConfigurations',
  components: {
    VueElementLoading,
    Multiselect
  },
  data() {
    return {
      // Filter data
      shipmentTypeList: [],
      reasonList: [],
      reason: '',
      subReasonMap: {},
      subreason: '',
      shipmentType: '',

      // Table data
      tableData: [],
      clientTableData: [],
      currentPage: 1,
      itemsPerPage: 50,
      totalPages: 1,
      totalItems: 0,
      searchQuery: '',

      // Audit data
      auditData: [],
      auditlogenum: ['reasonsubreason-config', 'client-config'],

      // UI state
      isreasonsubreasonSectionOpen: false,
      isClientSectionOpen: false,

      // User data
      myStr: '',
      username: '',
      userFirstLastName: '',
      globalTat: { opening: 9, reopening: 2 },
    }
  },

  computed: {
    reasonsubreasonData() {
      const found = this.auditData.find(item => item.logType === 'reasonsubreason-config')
      return found ? found.logs || [] : []
    },

    clientData() {
      const found = this.auditData.find(item => item.logType === 'client-config')
      return found ? found.logs || [] : []
    },

    filteredTableData() {
      let filtered = this.tableData || [];

      if (this.shipmentType && this.shipmentType.label) {
        filtered = filtered.filter(row => row.shipmentType === this.shipmentType.label);
      }
      if (this.reason && this.reason.value) {
        filtered = filtered.filter(row => row.reason === this.reason.value);
      }
      if (this.subreason && this.subreason.value) {
        filtered = filtered.filter(row => row.disputereasonid === this.subreason.value);
      }

      return filtered;
    }
  },

  mounted() {
    this.initializeUserData();
    this.loadInitialData();
  },

  methods: {
    // Initialization methods
    initializeUserData() {
      const userToken = window.localStorage.getItem('accessuserToken');
      this.myStr = userToken.replace(/"/g, '');
      this.username = window.localStorage.getItem('username');

      const userdetailEncrypt = window.localStorage.getItem('accessuserdata');
      const bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      const plaintext = bytes.toString(CryptoJS.enc.Utf8);
      const userdetail = JSON.parse(plaintext);
      this.userFirstLastName = userdetail.FirstName;
    },

    async loadInitialData() {
      await Promise.all([
        this.getShipmentType(),
        this.getAllReasonSubreason(),
        this.getclientlevelconfigs(),
        this.getaudittrail()
      ]);
    },

    // API methods
    async getShipmentType() {
      try {
        const input = { type: ["shipmentTypes"] };
        const apiResponse = await getShipmentTypeList(input, this.myStr);

        if (apiResponse.data.code === 200) {
          this.shipmentTypeList = apiResponse.data.data.map(item => ({
            label: item.Type,
            value: item.Value
          }));
        } else {
          this.$alertify.error(apiResponse.data.message);
        }
      } catch (error) {
        this.$alertify.error('Error fetching shipment types');
      }
    },

    async reasonSubReason() {
      this.resetFields();

      try {
        const input = {
          disputeRaisedType: "Client",
          taskType: this.shipmentType.value
        };
        const apiResponse = await getReasonSubReason(input, this.myStr);

        if (apiResponse.data.code === 200) {
          const reasonSubreasonData = apiResponse.data.data;

          this.reasonList = reasonSubreasonData.map(item => ({
            label: item.reason,
            value: item.reason
          }));

          this.subReasonMap = {};
          reasonSubreasonData.forEach(item => {
            this.subReasonMap[item.reason] = item.subReason.map(sub => ({
              label: sub.subReason,
              value: sub.disputereasonid
            }));
          });
        } else {
          this.$alertify.error("Dispute Reason Subreason error");
        }
      } catch (error) {
        this.$alertify.error("Error fetching reason sub-reason data");
      }
    },

    async getAllReasonSubreason() {
      try {
        const input = { disputeRaisedType: "Client" };
        const apiResponse = await getReasonSubReason(input, this.myStr);

        if (apiResponse.data.code === 200) {
          const reasonSubreasonData = apiResponse.data.data;
          const resArray = [];

          reasonSubreasonData.forEach(shipment => {
            const shipmentType = shipment.ShipmentType;
            shipment.reasonAndSubReason.forEach(reasonObj => {
              const reason = reasonObj.reason;
              reasonObj.subReason.forEach(sub => {
                resArray.push({
                  shipmentType,
                  reason,
                  subreason: sub.subReason,
                  disputereasonid: sub.disputereasonid,
                  imageProofMandatory: sub.isimage,
                  videoProofMandatory: sub.isvideo,
                  initialImageProofMandatory: sub.isimage,
                  initialVideoProofMandatory: sub.isvideo
                });
              });
            });
          });

          this.tableData = resArray;
        } else {
          this.$alertify.error("Dispute Reason Subreason error");
        }
      } catch (error) {
        this.$alertify.error("Error fetching reason sub-reason data");
      }
    },

    async getclientlevelconfigs() {
      try {
        const input = {
          type: "WHHandoverDispute", 
          page: this.currentPage,
          limit: this.itemsPerPage,
          search: this.searchQuery
        };
        const apiResponse = await clientlevelconfigs(input, this.myStr);

        if (apiResponse.data.code === 100) {
          this.clientTableData = apiResponse.data.data.map(obj =>
            Object.assign({}, obj, {
              isimage: obj.isimage,
              isvideo: obj.isvideo
            })
          );
          this.storeClientOriginalValues(this.clientTableData);
          this.totalPages = apiResponse.data.pagination.totalPages;
          this.totalItems = apiResponse.data.pagination.total;
        } else {
          this.$alertify.error(`Error: ${apiResponse.data.message}`);
        }
      } catch (error) {
        console.error('Error fetching client configs:', error);
        this.$alertify.error("Error in fetching client configs");
      }
    },

    async getaudittrail() {
      try {
        const promises = this.auditlogenum.map(async (logType) => {
          const input = { logtype: logType };
          const apiResponse = await getaudittrails(input, this.myStr);

          if (apiResponse.data.code === 200) {
            return {
              logType,
              logs: apiResponse.data.data
            };
          } else {
            this.$alertify.error("Error while fetching audit trail");
            return null;
          }
        });

        const results = await Promise.all(promises);
        this.auditData = results.filter(result => result !== null);
      } catch (error) {
        console.error('Error fetching audit trail:', error);
        this.$alertify.error("Error in fetching audit trail");
      }
    },

    // Change detection methods
    hasProofChanged(row) {
      return (
        row.imageProofMandatory !== row.initialImageProofMandatory ||
        row.videoProofMandatory !== row.initialVideoProofMandatory
      );
    },

    hasClientProofChanged(client) {
      if (!client.originalValues) return false;
      return (
        client.isimage !== client.originalValues.isimage ||
        client.isvideo !== client.originalValues.isvideo ||
        Number(client.reopenhours) != Number(client.originalValues.reopenhours) ||
        Number(client.disputehours) != Number(client.originalValues.disputehours)
      );
    },

    // Change tracking methods
    getChangedFieldsWithValues(row) {
      const changes = {};

      if (row.imageProofMandatory !== row.initialImageProofMandatory) {
        changes['Image Proof'] = {
          from: row.initialImageProofMandatory,
          to: row.imageProofMandatory
        };
      }

      if (row.videoProofMandatory !== row.initialVideoProofMandatory) {
        changes['Video Proof'] = {
          from: row.initialVideoProofMandatory,
          to: row.videoProofMandatory
        };
      }

      return changes;
    },

    getClientChangedFieldsWithValues(client) {
      const changes = {};

      if (client.isimage !== client.originalValues.isimage) {
        changes['Image Proof'] = {
          from: client.originalValues.isimage,
          to: client.isimage
        };
      }

      if (client.isvideo !== client.originalValues.isvideo) {
        changes['Video Proof'] = {
          from: client.originalValues.isvideo,
          to: client.isvideo
        };
      }

      if (Number(client.disputehours) !== Number(client.originalValues.disputehours)) {
        changes['Dispute Hours'] = {
          from: Number(client.originalValues.disputehours),
          to: Number(client.disputehours)
        };
      }

      if (Number(client.reopenhours) !== Number(client.originalValues.reopenhours)) {
        changes['Reopen Hours'] = {
          from: Number(client.originalValues.reopenhours),
          to: Number(client.reopenhours)
        };
      }

      return changes;
    },

    // Update methods
    async updateProofsConfig(row, type) {
      try {
        const changes = this.getChangedFieldsWithValues(row);
        const auditlog = this.createAuditLog(changes, type, {
          shipmenttype: row.shipmentType,
          reason: row.reason,
          subreason: row.subreason
        });

        const payload = {
          type: type,
          disputereasonid: row.disputereasonid,
          isimage: row.imageProofMandatory,
          isvideo: row.videoProofMandatory,
          audittrail: auditlog
        };

        const response = await updateProofs(payload, this.myStr);

        if (response.data.code === 200) {
          row.initialImageProofMandatory = row.imageProofMandatory;
          row.initialVideoProofMandatory = row.videoProofMandatory;
          this.getaudittrail()
          this.$alertify.success(response.data.message);
        } else {
          this.$alertify.error(response.data.message);
        }

        // this.resetall();
      } catch (err) {
        console.error("Update error:", err);
        this.$alertify.error(err.message);
      }
    },

    async updateClientProofsConfig(idx, type) {
      try {
        const client = this.clientTableData[idx];
        const changes = this.getClientChangedFieldsWithValues(client);
        const auditlog = this.createAuditLog(changes, type, {
         clientid: client.clientid,
         clientname: client.clientname,
         clientbusinessaccountid:client.clientbusinessaccountid,
         clientbusinessaccountname:client.clientbusinessaccountname
        });
        
        const payload = {
          id:client.id,
          type: type,
          clientid: client.clientid,
          isimage: client.isimage,
          isvideo: client.isvideo,
          disputehours: Number(client.disputehours),
          reopenhours: Number(client.reopenhours),
          audittrail: auditlog
        };

        const response = await updateProofs(payload, this.myStr);

        if (response.data.code === 200) {
          client.originalValues.isimage = client.isimage;
          client.originalValues.isvideo = client.isvideo;
          client.originalValues.disputehours = Number(client.disputehours);
          client.originalValues.reopenhours = Number(client.reopenhours);
          this.getaudittrail()
          this.$alertify.success(response.data.message);
        } else {
          this.$alertify.error(response.data.message);
        }

        // this.resetall();
      } catch (err) {
        console.error("Update error:", err);
        this.$alertify.error(err.message);
      }
    },

    // Utility methods
    createAuditLog(changes, type, metadata) {
      const auditlog = [];

      for (const [setting, value] of Object.entries(changes)) {
        auditlog.push({
          configtype: type,
          log: Object.assign({}, metadata, {
            setting,
            oldvalue: value.from,
            newvalue: value.to
          }),
          createdby: this.username,
        });
      }

      return auditlog;
    },

    storeClientOriginalValues(clientData) {
      clientData.forEach(client => {
        client.originalValues = {
          isimage: client.isimage,
          isvideo: client.isvideo,
          reopenhours: Number(client.reopenhours),
          disputehours: Number(client.disputehours)
        };
      });
    },

    resetFields() {
      this.reason = '';
      this.reasonList = [];
      this.subreason = '';
      this.subReasonMap = {};
    },

    resetFilters() {
      this.shipmentTypeList = [];
      this.shipmentType = '';
      this.resetFields();
      this.getShipmentType();
    },

    resetall() {
      // Add any additional reset logic here
    },

    // UI toggle methods
    togglereasonSubSection() {
      this.isreasonsubreasonSectionOpen = !this.isreasonsubreasonSectionOpen;
    },

    toggleClientSection() {
      this.isClientSectionOpen = !this.isClientSectionOpen;
    },
    handleSearch() {
      if (this.searchQuery.trim().length > 0 && this.searchQuery.trim().length < 4) {
        this.$alertify.error("Type at least 4 characters");
        return;
      }
      this.currentPage = 1;
      this.getclientlevelconfigs();
    },
  
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.getclientlevelconfigs();
      }
    },
    resetSearch() {
      this.searchQuery = "";
      this.currentPage = 1;
      this.getclientlevelconfigs();
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/components/DisputeConfigurations/DisputeConfigurations.component.js